import PropTypes from 'prop-types';

const sizes = {
  none: '0',
  small: '0.5rem',
  medium: '1rem',
  large: '1.5rem',
};

const locations = {
  'block-end': 'marginBlockEnd',
};

const ExpandableSectionHeader = ({
  children,
  id,
  isShown,
  spacing,
  toggleContent,
}) => {
  const { location, size } = spacing;

  return (
    <div
      aria-expanded={isShown}
      className="flex flex-row cursor-pointer"
      id={id}
      onClick={() => toggleContent(!isShown)}
      onKeyDown={() => {}}
      role="button"
      style={{ [locations[location]]: sizes[size] }}
      tabIndex="0"
    >
      {children}
    </div>
  );
};

ExpandableSectionHeader.defaultProps = {
  spacing: {
    location: 'block-end',
    size: 'small',
  },
};

ExpandableSectionHeader.propTypes = {
  children: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
  isShown: PropTypes.bool.isRequired,
  spacing: PropTypes.shape({
    location: PropTypes.oneOf(['block-end']),
    size: PropTypes.oneOf(['none', 'small', 'medium', 'large']),
  }),
  toggleContent: PropTypes.func.isRequired,
};

export default ExpandableSectionHeader;
